import PropTypes from "prop-types"
import Markdown from "react-markdown"

const RichText = ({ data }) => {
  return (
    <div className="prose prose-lg container max-w-3xl mx-auto p-4 my-16">
      <Markdown>{data.content}</Markdown>
    </div>
    
  )
}

RichText.propTypes = {
  data: PropTypes.shape({
    content: PropTypes.string,
  }),
}

export default RichText